"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ThreeLineViewFirstColumn_1 = require("./ThreeLineViewFirstColumn");
var ThreeLineViewSecondColumn_1 = require("./ThreeLineViewSecondColumn");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var ThreeLineViewListItem = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeLineViewListItem, _super);
    function ThreeLineViewListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeLineViewListItem.prototype.render = function () {
        return (React.createElement("div", { className: styles.threeColumnViewContainer },
            React.createElement(ThreeLineViewFirstColumn_1.default, { isSelected: this.props.isSelected, isUnread: this.props.isUnread }),
            React.createElement(ThreeLineViewSecondColumn_1.default, { isSelected: this.props.isSelected, isUnread: this.props.isUnread, senderTexts: this.props.senderLineTexts, subjectTexts: this.props.subjectLineTexts, previewTexts: this.props.previewLineTexts, iconBarUrl: this.props.iconBarUrl, originalPriceTexts: this.props.originalPriceTexts, currentPriceTexts: this.props.currentPriceTexts, adId: this.props.adId })));
    };
    ThreeLineViewListItem = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThreeLineViewListItem);
    return ThreeLineViewListItem;
}(React.Component));
exports.default = ThreeLineViewListItem;
//# sourceMappingURL=ThreeLineViewListItem.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/ThreeLineViewListItem.js
// module id = 6002
// module chunks = 67